import { Modal, notification } from 'antd';
import { useNavigate } from 'react-router-dom';
// import { api } from 'utils/apiRoutes';
import React, { useMemo } from 'react';
import { POST } from '../utils';
const Context = React.createContext({ name: 'Default' });

const useNotice = () => {
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const contextValue = useMemo(() => ({ name: 'Ant Design' }), []);

  const success = (message: string, url?: any, state?: object) => {
    Modal.success({
      content: message,
      onOk: () => {
        if (url !== 'reload') {
          navigate(url, { state: state });
        } else {
          window.location.reload();
        }
      },
      style: {
        top: '40%',
      },
    });
  };
  const successChangePassword = (
    message: string,
    url?: any,
    state?: object,
  ) => {
    Modal.success({
      content: message,
      onOk: () => {
        if (url !== 'reload') {
          navigate(url, { state: state });
        } else {
          window.location.reload();
        }
      },
      style: {
        top: '10%',
        right: '8%',
      },
    });
  };

  const successNotification = (
    message?: string,
    errorCallback?: () => void,
    subDescription?: string,
  ) => {
    notification.success({
      message: (
        <p
          style={{
            color: '#646464',
            fontWeight: 500,
            fontSize: '16px',
            marginBottom: '-1px',
            lineHeight: '1',
          }}
        >
          Success
        </p>
      ),
      description: !subDescription ? (
        <p
          style={{
            color: '#646464',
            fontWeight: 400,
            fontSize: 12,
            lineHeight: '1.5',
          }}
        >
          {message}
        </p>
      ) : (
        <div
          style={{
            color: '#646464',
            fontWeight: 400,
            fontSize: 12,
            display: 'flex',
            flexWrap: 'wrap',
            columnGap: '4px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <div
          // style={{
          //   overflow: 'hidden',
          //   textOverflow: 'ellipsis',
          //   whiteSpace: 'nowrap',
          //   width: 'fit-content',
          // }}
          >
            {message + subDescription}
          </div>
        </div>
      ),
      style: {
        width: '280px',
      },
      duration: 2,
      onClose: () => {
        if (errorCallback) {
          errorCallback();
        }
      },
    });
  };
  const warningNotification = (
    message?: string,
    errorCallback?: () => void,
    subDescription?: string,
  ) => {
    notification.warning({
      message: (
        <p
          style={{
            color: '#646464',
            fontWeight: 500,
            fontSize: '16px',
            marginBottom: '-1px',
            lineHeight: '1',
          }}
        >
          Warning
        </p>
      ),
      description: !subDescription ? (
        <p
          style={{
            color: '#646464',
            fontWeight: 400,
            fontSize: 12,
            lineHeight: '1.5',
          }}
        >
          {message}
        </p>
      ) : (
        <div
          style={{
            color: '#646464',
            fontWeight: 400,
            fontSize: 12,
            display: 'flex',
            flexWrap: 'wrap',
            columnGap: '4px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <div
          // style={{
          //   overflow: 'hidden',
          //   textOverflow: 'ellipsis',
          //   whiteSpace: 'nowrap',
          //   width: 'fit-content',
          // }}
          >
            {message + subDescription}
          </div>
        </div>
      ),
      style: {
        width: '280px',
      },
      duration: 2,
      onClose: () => {
        if (errorCallback) {
          errorCallback();
        }
      },
    });
  };
  const errorNotification = (
    message?: string,
    errorCallback?: () => void,
    subDescription?: string,
  ) => {
    notification.warning({
      message: (
        <p
          style={{
            color: '#646464',
            fontWeight: 500,
            fontSize: '16px',
            marginBottom: '-1px',
            lineHeight: '1',
          }}
        >
          Error
        </p>
      ),
      description: !subDescription ? (
        <p
          style={{
            color: '#646464',
            fontWeight: 400,
            fontSize: 12,
            lineHeight: '1.5',
          }}
        >
          {message}
        </p>
      ) : (
        <div
          style={{
            color: '#646464',
            fontWeight: 400,
            fontSize: 12,
            display: 'flex',
            flexWrap: 'wrap',
            columnGap: '4px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <div
          // style={{
          //   overflow: 'hidden',
          //   textOverflow: 'ellipsis',
          //   whiteSpace: 'nowrap',
          //   width: 'fit-content',
          // }}
          >
            {message + subDescription}
          </div>
        </div>
      ),
      style: {
        width: '280px',
      },
      duration: 2,
      onClose: () => {
        if (errorCallback) {
          errorCallback();
        }
      },
    });
  };

  const error = (message: string, data?: any, errorCallback?: () => void) => {
    Modal.error({
      title: (
        <span style={{ fontWeight: 600, fontSize: 16, color: '#000000' }}>
          {message}
        </span>
      ),
      content: (
        <div
          style={{
            width: '100%',
            justifyContent: 'center',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            fontSize: '14px',
            fontWeight: 500,
            color: '#E02C2C',
          }}
        >
          {data}
        </div>
      ),
      width: '340px',
      style: {
        top: '40%',
      },
      onOk: () => {
        if (errorCallback) {
          errorCallback();
        }
      },
    });
  };
  const errorType = (message: string, data?: any) => {
    Modal.error({
      title: (
        <span style={{ fontWeight: 600, fontSize: 16, color: '#000000' }}>
          {message}
        </span>
      ),
      content: (
        <div
          style={{
            width: '110%',
            justifyContent: 'center',
            textAlign: 'center',
            display: 'flex',
            marginTop: '5px',
            flexDirection: 'row',
            fontSize: '14px',
            fontWeight: 400,
            color: '#E02C2C',
            marginLeft: '-35px',
          }}
        >
          {data}
        </div>
      ),
      width: '400px',
      style: {
        top: '40%',
      },
    });
  };
  const postNoti = async (
    type: string,
    action: string,
    message: string,
    url: string,
  ) => {
    return await POST('/api/notification/create/', {
      type: type,
      action: action,
      data: {
        message: message,
        url: url,
        timestamp: new Date(),
      },
    });
  };
  return {
    success: success,
    error: error,
    errorType: errorType,
    postNoti,
    successNotification: successNotification,
    errorNotification: errorNotification,
    warningNotification: warningNotification,
    successChangePassword: successChangePassword,
    contextHolder: contextHolder,
  };
};
export default useNotice;
